
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AnalysisIssueUnion": [
      "StaticAnalysisIssue",
      "AIReviewIssue"
    ],
    "MaskPrimaryKeyNode": [
      "AccessToken",
      "Agent",
      "AgentAction",
      "AgentMemory",
      "AgentsProduct",
      "Analyzer",
      "AnalyzerCISnippet",
      "AnalyzerReview",
      "AnalyzerSyncJob",
      "AuditLog",
      "AutoOnboardEvent",
      "AutofixRun",
      "BilledRepositoryTarget",
      "CallStackFrame",
      "Check",
      "CheckIssue",
      "CheckPackage",
      "CodeQualityProduct",
      "ConfigTemplate",
      "EnterpriseBilledRepositoryTarget",
      "EnterpriseGroup",
      "EnterpriseInstallationSetup",
      "EnterpriseTeam",
      "EnterpriseUser",
      "FeatureDefinition",
      "GroupTeamMembership",
      "GroupUserMembership",
      "IDEProduct",
      "IdentityProvider",
      "Issue",
      "IssuePriority",
      "IssuePriorityType",
      "License",
      "Metric",
      "Owner",
      "OwnerAIPolicy",
      "OwnerDynamicRiskConfig",
      "OwnerLicensePolicy",
      "OwnerSCAPolicy",
      "OwnerSetting",
      "PR",
      "Package",
      "PackageUpgradeSummary",
      "PackageVersion",
      "ProductSubscription",
      "PublicReport",
      "Repository",
      "RepositoryCollaborator",
      "RepositoryComplianceReportItem",
      "RepositoryCoverageReportItem",
      "RepositoryGroup",
      "RepositoryGroupSetting",
      "RepositoryIssue",
      "RepositoryMetricValue",
      "RepositoryPackage",
      "RepositoryScaTargetReportItem",
      "RepositorySetting",
      "RepositoryTarget",
      "Run",
      "Runner",
      "RunnerApp",
      "RuntimeLog",
      "SCACheck",
      "SCAProduct",
      "SSOIdentityProvider",
      "SilenceRule",
      "SourceableRepository",
      "Team",
      "TeamBasePermissionSet",
      "TeamMember",
      "TeamMemberAdditionRequest",
      "TeamMemberInvitation",
      "Transaction",
      "TransformerReview",
      "TransformerRun",
      "TransformerTool",
      "User",
      "UserPreference",
      "UserSocialConnection",
      "VerifiableDomain",
      "Vulnerability",
      "VulnerabilityCallStack",
      "VulnerabilityOccurrence",
      "VulnerabilityRemediationFixPath",
      "VulnerabilityRemediationFixPathUpdate",
      "VulnerabilityRemediationPatchRun",
      "Webhook",
      "WebhookEventDelivery",
      "WebhookEventTypes"
    ],
    "Product": [
      "AgentsProduct",
      "CodeQualityProduct",
      "IDEProduct",
      "SCAProduct"
    ],
    "SubscriptionSponsor": [
      "Owner"
    ]
  }
};
      export default result;
    